import { AuthBackdrop } from './AuthBackdrop'
import { LoginSection } from './LoginSection'
import { TitleSection } from './TitleSection'

const layoutStyles = 'grid h-dvh w-full grid-cols-1 md:grid-cols-[1fr,1fr] py-24 px-20 md:gap-12 gap-6 absolute top-0 items-center'

const AuthPage = () => (
    <div className="relative h-dvh overflow-hidden">
        <AuthBackdrop />

        <div className={layoutStyles}>
            <TitleSection />
            <LoginSection />
        </div>
    </div>
)

export default AuthPage
